import { z } from "zod";
import { ShortText, CausalStep, RetiredCausalStepV1 } from "./common.js";
/**
 * Causal Chain — Look, multi. 5-Whys horizontal chain. Optional
 * `problem` head card precedes the first Why. Root step is flagged
 * with `isRoot` for the emerald target highlight.
 */
export const CausalChainParamsSchema = z
    .object({
    problem: ShortText.optional(),
    steps: z.array(CausalStep).max(20),
})
    .strict();
/** The published params shape before PB-4923 added step ids. See `RetiredCausalStepV1`. */
export const RetiredCausalChainParamsV1Schema = z
    .object({
    problem: ShortText.optional(),
    steps: z.array(RetiredCausalStepV1).max(20),
})
    .strict();
export const defaultCausalChainParams = {
    steps: [],
};
//# sourceMappingURL=causalChain.js.map